import { Outlet } from "react-router-dom";
import NavigationPanel from "./NavigationPanel";
import { Grid } from "@mui/material";

export default function UnauthenticatedBaseLayout() {
  return (
    <div className="base-layout">
      <main style={{ display: 'flex', height: '100vh', width: '100vw' }}>
        <NavigationPanel email={''} name={''} authenticated={false}></NavigationPanel>
        <Grid container style={{ flexGrow: 1, }}>
            <Outlet />
        </Grid>
      </main>
    </div>
  );
}
